import { CsvBuilder } from "filefy";
import "jspdf-autotable";
const jsPDF = typeof window !== "undefined" ? require("jspdf").jsPDF : null;

export const ExportCsv = async (_columns, _data, title, exportRecords) => {
  const __data = await exportRecords();
  const [columns, data] = getTableData(_columns, __data)
  let fileName = title;

  const builder = new CsvBuilder(fileName + ".csv");
  builder
    .setDelimeter(",")
    .setColumns(columns.map((columnDef) => columnDef.title))
    .addRows(data)
    .exportFile();
};


export const ExportPdf = async (_columns, _data, title, exportRecords) => {
  const __data = await exportRecords();
  if (jsPDF !== null) {
    const [columns, data] = getTableData(_columns, __data);
    let fileName = title;

    let content = {
      startY: 50,
      head: [columns.map((columnDef) => columnDef.title)],
      body: data,
    };

    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";

    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    doc.text(fileName, 40, 40);
    doc.autoTable(content);
    doc.save(
      (fileName || "data") + ".pdf"
    );
  }
}

const getTableData = (_columns, _data) => {
    const columns = _columns.filter(
      (columnDef) =>
        (!columnDef.hidden || columnDef.export === true) &&
        columnDef.export !== false &&
        columnDef.field
    )
    .sort((a, b) =>
      a.tableData.columnOrder > b.tableData.columnOrder ? 1 : -1
    );
  const data = (_data).map((rowData) =>
    columns.map((columnDef) => {
      let val = rowData[columnDef.field]
      if(columnDef.render) {
        const rendered = columnDef.render(rowData);
        if(['string', 'number', 'boolean'].includes(typeof(rendered))) {
          val = rendered;
        } else if(columnDef.type === "date") {
          val = new Date(val).toLocaleString()
        }
      } else if(columnDef.type === "date") {
        val = new Date(val).toLocaleString()
      };
      return val
    })
  );

  return [columns, data];
};